import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PrivateRoutes from './routes/private.routes';
import PublicRoutes from './routes/public.routes';
import useAuthCheck from './shared/hooks/useAuthCheck';
import Loader from './shared/components/Loader';
import WBCONST from './shared/constants/wb.const';
import PATH from './shared/constants/path.const';
// import setColorVariables from './theme/colorVariables';
import SessionHandling from './pages/common/SessionHandle';
import { useLogoutMutation } from './services/auth/auth.api';
import { getCookie } from './shared/utils/utils';
import ApplicationLogout from './pages/common/logout/ApplicationLogout';
import ApplicationLogoutAPI from './pages/common/logout/ApplicationLogoutAPI';
import useGetHost from './shared/hooks/useGetHost';
import { authConst } from './pages/common/auth/const/auth.const';
import { getReturnTarget, readReturnUrl } from './shared/utils/returnUrl';

function App() {
  const { token } = useAuthCheck();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [sessionCreated, setSessionCreated] = useState(false);
  const { consolePrefixList } = WBCONST;
  const { internalHosts } = authConst;
  const host = useGetHost();

  const navigate = useNavigate();
  const location = useLocation();
  const logoutUser = useLogoutMutation();
  // setColorVariables();
  const userType = useMemo(() => (internalHosts.includes(host) ? 'I' : 'E'), [host]);

  useEffect(() => {
    const staySignedIn = getCookie('keep-me-signed-in');
    if (staySignedIn !== 'Y') {
      ApplicationLogout(dispatch, navigate, getReturnTarget(location));
      ApplicationLogoutAPI(true, logoutUser, dispatch, navigate);
    }
    setLoading(false);
    // setColorVariables();
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      const originalConsoleLog = console.log;
      console.log = (...args) => {
        if (
          args.length &&
          typeof args[0] === 'string' &&
          consolePrefixList.some((prefix) => args[0].startsWith(prefix))
        ) {
          originalConsoleLog(...args);
        }
      };
    }
  }, []);

  useEffect(() => {
    if (location.pathname === '/' && token) {
      const returnUrl = readReturnUrl(location.search);
      if (returnUrl) {
        navigate(returnUrl, { replace: true });
      } else if (userType !== 'I') {
        navigate(PATH.PROJECTS);
      } else {
        navigate(PATH.PRODUCT_DEVELOPMENT);
      }
    }
  }, [location.pathname, location.search, token, userType, navigate]);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      console.info = function () {};
      console.warn = function () {};
      console.error = function () {};
      console.debug = function () {};
      console.trace = function () {};
    }
  }, []);

  useEffect(() => {
    if (!sessionCreated) {
      SessionHandling(dispatch, setSessionCreated, logoutUser);
    }
  }, []);

  return (
    <div className="App">
      {loading && <Loader />}
      {!loading && token && <PrivateRoutes />}
      {!loading && !token && <PublicRoutes />}
    </div>
  );
}

export default App;
